<div>
  <button class="btn-no-color right">
    <ion-label>Seguinte</ion-label>
  </button>
</div>